/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-04-25 15:20:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-26 09:53:11
 */
import React, {Component} from 'react'
import {Switch, Route, Link} from 'react-router-dom'
import {connect} from 'react-redux'
import './index.css'
import tx from '../../../statics/suzhou.jpg'
import MyAccount from './components/MyAccount'
import MyCoin from './components/MyCoin'
import MyRole from './components/MyRole'
import MyLoginLog from './components/MyLoginLog'
import MyPassword from './components/MyPassword'
import {Layout, Menu, Divider, Avatar} from 'antd';
import Header4 from '../../Header/Header4'
import MyOrder from './components/MyOrder'
import ChangePassword from './components/MyAccount/changePassword/changePassword'
import ChangePersonalInfo from './components/MyAccount/changePersonalInfo/changePersonalInfo'
import UserOrder from './components/MyOrder/components/UserOrder'
import icon_user from './img/icon_user.png'
import icon_points from './img/icon_points.png'
import icon_menu from './img/icon_menu.png'
import Iframe from '../Iframe/index'


const {SubMenu} = Menu;
const menudata = [
    {
        name: '我的账户',
        path: '/usercenter/myaccount',
        icon: icon_user
    }, {
        name: '我的积分',
        path: '/usercenter/mycoin',
        icon: icon_points
    }
]

class UserCneter extends Component {
    state = {
        menuValue: ['0']
    };

    componentDidMount() {
        this.setMenuValue()
    }

    componentDidUpdate(prevProps, preState) {
        let value
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setMenuValue()
        }
    }

    pushPage = (path, state) => {
        this.props.history.push(path + `?id=${state}`)
    }
    setMenuValue = () => {
        let value
        switch (this.props.location.pathname) {
            case '/usercenter/myaccount':
                value = '0';
                this.setState({menuValue: [value]})
                break;
            case '/usercenter/mycoin':
                value = '1';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/DownLoadOrder':
                value = 'a';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/UploadOrder':
                value = 'b';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/FutureOrder':
                value = 'c';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/ProduceOrder':
                value = 'd';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/SimulationOrder':
                value = 'e';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/ProduceTestOrder':
                value = 'f';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/TecTestOrder':
                value = 'g';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/GroundDataOrder':
                value = 'h';
                this.setState({menuValue: [value]})
                break;
            case '/userCenter/MicrowaveOrder':
                value = 'i';
                this.setState({menuValue: [value]});
                break;
            default:
                value = '0';
                this.setState({menuValue: [value]})
                break;
        }
    }

    render() {
        return (
            <>
                <Header4></Header4>
                <div className='usercenter-main'>
                    <div className='usercenter-continer'>
                        <div className='usercenter-sider'>
                            <div className='usercenter-username-panel'>
                                <img className='usercenter-username-avatar' src={this.props.user.avatar}></img>
                                <div className='usercenter-username-text'>
                                    <div className='usercenter-username'>
                                        {this.props.user.realName}
                                    </div>
                                    <div className='usercenter-userId'>
                                        {this.props.user.userName}
                                    </div>
                                </div>

                            </div>
                            <Menu
                                className='usercenter-menu'
                                mode="inline"
                                selectedKeys={this.state.menuValue}
                                defaultSelectedKeys={this.state.menuValue}
                                defaultOpenKeys={['sub1']}
                            >
                                {
                                    menudata.map((data, index) =>
                                        <Menu.Item key={index} className='usercenter-menuitem'>
                                            <div className='usercenter-menu-inline'>
                                                <img className='usercenter-menuicon' src={data.icon}></img>
                                                <Link to={data.path}> {data.name}</Link>
                                            </div>
                                        </Menu.Item>
                                    )

                                }
                                <SubMenu
                                    className='usercenter-menuitem'
                                    title={
                                        <div className='usercenter-menu-inline'>
                                            <img className='usercenter-menuicon' src={icon_menu}></img>
                                            <span>我的订单</span>
                                        </div>
                                    }
                                    key="sub1"
                                >
                                    <Menu.Item key='a' className='usercenter-menuitem'><Link
                                        to={'/userCenter/DownLoadOrder'}> 下载订单</Link></Menu.Item>
                                    <Menu.Item key='b' className='usercenter-menuitem'><Link
                                        to={'/userCenter/UploadOrder'}> 上传订单</Link></Menu.Item>
                                    <Menu.Item key='d' className='usercenter-menuitem'><Link
                                        to={'/userCenter/ProduceOrder'}> 生产订单</Link></Menu.Item>
                                    <Menu.Item key='c' className='usercenter-menuitem'><Link
                                        to={'/userCenter/FutureOrder'}> 未来订单</Link></Menu.Item>
                                    {/*<Menu.Item key='e' className='usercenter-menuitem'><Link*/}
                                    {/*    to={'/userCenter/SimulationOrder'}> 仿真订单</Link></Menu.Item>*/}
                                    <Menu.Item key='f' className='usercenter-menuitem'><Link
                                        to={'/userCenter/ProduceTestOrder'}> 产品检验订单</Link></Menu.Item>
                                    <Menu.Item key='g' className='usercenter-menuitem'><Link
                                        to={'/userCenter/TecTestOrder'}> 技术检验订单</Link></Menu.Item>
                                    <Menu.Item key='h' className='usercenter-menuitem'><Link
                                        to={'/userCenter/GroundDataOrder'}> 地面数据订单</Link></Menu.Item>
                                    <Menu.Item key='i' className='usercenter-menuitem'><Link
                                        to={'/userCenter/MicrowaveOrder'}> 光学微波仿真订单</Link></Menu.Item>
                                </SubMenu>
                            </Menu>
                        </div>
                        <div className="usercenter-content">
                            <Switch>
                                <Route path='/usercenter/myaccount' exact component={MyAccount}/>
                                <Route path='/usercenter/myaccount/changePassword' exact component={ChangePassword}/>
                                <Route path='/usercenter/myaccount/changePersonalInfo' exact
                                       component={ChangePersonalInfo}/>
                                <Route path='/usercenter/mycoin' exact component={MyCoin}/>
                                <Route path='/usercenter/myloginlog' exact component={MyLoginLog}/>
                                <Route path='/usercenter/mypassword' exact component={MyPassword}/>
                                <Route path='/usercenter/myorder' exact component={MyOrder}/>
                                <Route path='/usercenter/myrole' exact component={MyRole}/>
                                <Route path='/userCenter/DownLoadOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/UploadOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/ProduceOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/FutureOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/SimulationOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/ProduceTestOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/TecTestOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/MicrowaveOrder' exact component={UserOrder}/>
                                <Route path='/userCenter/GroundDataOrder' exact
                                       component={() => <iframe className='GroundDataOrder'
                                                                src={`https://landv.aircas.ac.cn:10088/OrderDownload/#/DownloadAuditList?token=${this.props.user.token}&show=2`}></iframe>}/>
                            </Switch>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({})

export default connect(mapState, mapDispatch)(UserCneter);
// export default UserCneter